<template>
  <!-- Thin wrapper over PrimeVue Button, the design system's public API for buttons. Forwards every
       prop, event, and slot. Theming and defaults live in preset.js. Use this, not primevue/button. -->
  <Button
    v-bind="$attrs"
    :disabled="disabled || loading"
    :loading="loading"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps"
      />
    </template>
  </Button>
</template>

<script setup>
import Button from 'primevue/button';

defineOptions({ inheritAttrs: false });

// Declared so a bare `disabled` casts to true. PrimeVue lets an explicit `disabled: false` in its
// attrs beat its own "loading means disabled" rule, so the wrapper passes the combined value.
defineProps({
  disabled: Boolean,
  loading: Boolean,
});
</script>
